import React from 'react'
import { Hero, AbtLPTB, Svc, WhyChooseUs, Clients, CTA } from '../../components'

const Home = () => {
  return (
    <div>
        <Hero />
        <AbtLPTB />
        <Svc />
        <WhyChooseUs />
        <Clients />
        <CTA />
    </div>
  )
}

export default Home
